export default __webpack_public_path__ + "4d290d1daf318f6917c17456bbebf970.png";